import { Skeleton as SkeletonA } from 'antd';
import cs from 'classnames';
import type { ComponentProps } from 'react';
import { resolveClassNames } from '../utils';
import styles from './skeleton.module.css';

export type SkeletonProperties = ComponentProps<typeof SkeletonA>;

const Skeleton = ({ classNames, ...props }: SkeletonProperties) => (
  <SkeletonA
    classNames={resolveClassNames(classNames, (resolvedClassNames) => ({
      ...resolvedClassNames,
      title: cs(styles['ui-skeleton-title'], resolvedClassNames?.title),
    }))}
    {...props}
  />
);

Skeleton.Avatar = SkeletonA.Avatar;
Skeleton.Button = SkeletonA.Button;
Skeleton.Input = SkeletonA.Input;
Skeleton.Image = SkeletonA.Image;
Skeleton.Node = SkeletonA.Node;

export default Skeleton;
